import React, { useState } from 'react';
import { toast } from 'react-toastify';
import WebsiteService from '../../services/WebsiteService';

const AddWebsiteModal = ({ website, onClose }) => {
  const [formData, setFormData] = useState({
    name: website?.name || '',
    url: website?.url || '',
    tech: website?.tech || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.url.trim()) {
      toast.error('Name and URL are required.');
      return;
    }

    try {
      if (website) {
        await WebsiteService.updateWebsite(website.id, formData); // API call to update
        toast.success('Website updated successfully.');
      } else {
        await WebsiteService.createWebsite(formData); // API call to add
        toast.success('Website added successfully.');
      }
      onClose();
    } catch (error) {
      toast.error(error.message || 'Failed to save website.');
    }
  };

  return (
    <div className="modal show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{website ? 'Edit Website' : 'Add Website'}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group mb-3">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label>URL</label>
                <input
                  type="url"
                  className="form-control"
                  name="url"
                  value={formData.url}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label>Technology Used</label>
                <input
                  type="text"
                  className="form-control"
                  name="tech"
                  value={formData.tech}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddWebsiteModal;
